import './polyfills';
import React from 'react';
import ReactDOM from "react-dom/client";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './index.css';
import App from './component/app/App';
import reportWebVitals from './reportWebVitals';
import {CssBaseline, ThemeProvider} from "@mui/material";
import {Provider} from "react-redux";
import {store} from "./store";
import {BrowserRouter} from "react-router-dom";
import './config/i18n'
import './assets/styles/Toastify.css';
import {ToastContainer} from "react-toastify";
import {CloseButton} from "./component/shared/toast/toast-close-button/ToastCloseButton";
import {theme} from "./util/theme/theme";
import en from 'javascript-time-ago/locale/en.json'
import mk from 'javascript-time-ago/locale/mk.json'
import sq from 'javascript-time-ago/locale/sq.json'
import TimeAgo from "javascript-time-ago";
import 'leaflet/dist/leaflet.css'
import * as Sentry from '@sentry/react';
import "swiper/css"
import 'swiper/css/navigation'
import 'swiper/css/effect-fade'
import 'react-image-gallery/styles/css/image-gallery.css';
import 'video-react/dist/video-react.css';
import HelmetWrapper from "./HelmetWrapper";
import pkg from '../package.json';

const appName = pkg.name;
const appVersion = pkg.version;

TimeAgo.addDefaultLocale(mk)
TimeAgo.addLocale(en)
TimeAgo.addLocale(sq)

Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.1,
    environment: process.env.NODE_ENV,
    release: `${appName}@${appVersion}`,
    replaysSessionSampleRate: process.env.NODE_ENV === 'production' ? 0.05 : 1.0,
    replaysOnErrorSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
    <BrowserRouter>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                    <CssBaseline/>
                    <ToastContainer autoClose={4000}
                                    hideProgressBar
                                    closeButton={CloseButton}/>
                    <HelmetWrapper>
                        <App/>
                    </HelmetWrapper>
            </ThemeProvider>
        </Provider>
    </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
